import Index from '@/pages/device/Index'
import List from '@/pages/device/List'
import Request from '@/pages/device/Request'

export default {
  path: 'device',
  component: Index,
  children: [
    {
      path: 'index',
      component: List
    },
    {
      path: 'request',
      component: Request
    }
  ]
}

